import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../RootState';
import { getPermissionsApi } from './api';
import { RetentionFlags } from './permissions.types';

export const fetchRetentionPermissions = createAsyncThunk<RetentionFlags, void, { state: RootState }>(
    'permissions/fetchRetentionPermissions',
    async (_, { getState }) => {
        const token = getState().User?.token ?? '';
        return getPermissionsApi(token);
    },
    {
        condition: (_, { getState }) => {
            const status = getState().permissions?.status;
            return status === 'idle';
        },
    },
);
